import React from 'react'

const FeedGallery = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3" enableBackground="new 0 0 28.3 28.3">
    <g transform="translate(2 -4)">
      <g mask="url(#c)">
        <path
          className="st2"
          d="M-2.4 1.9H7c.9 0 1.6.7 1.6 1.6V13c0 .9-.7 1.6-1.6 1.6h-9.4c-.9-.1-1.6-.8-1.6-1.6V3.5c0-.9.7-1.6 1.6-1.6zM-3.2 17.7h11c.4 0 .8.4.8.8s-.4.8-.8.8h-11c-.4 0-.8-.4-.8-.8 0-.5.4-.8.8-.8zM-3.2 20.8h11c.4 0 .8.4.8.8s-.4.8-.8.8h-11c-.4 0-.8-.4-.8-.8s.4-.8.8-.8z"
          transform="translate(2 6)"
        />
        <g>
          <path
            className="st2"
            d="M3.3 1.9h9.4c.9 0 1.6.7 1.6 1.6V13c0 .9-.7 1.6-1.6 1.6H3.3c-.9 0-1.6-.7-1.6-1.6V3.5c0-.9.8-1.6 1.6-1.6zM2.5 17.7h11c.4 0 .8.4.8.8s-.4.8-.8.8h-11c-.4 0-.8-.4-.8-.8 0-.5.4-.8.8-.8zM2.5 20.8h11c.4 0 .8.4.8.8s-.4.8-.8.8h-11c-.4 0-.8-.4-.8-.8s.4-.8.8-.8z"
            transform="translate(12 6)"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default FeedGallery
